<template>
  <b-container class="search-area" fluid="lg">
    <b-form-row class="mb-5">
      <b-col v-if="!isTutor" cols="4">
        <h3 class="common__search-title">Tutor</h3>
        <SearchTutor v-model="conditions.targetTutor" />
      </b-col>
      <b-col cols="8">
        <h3 class="common__search-title">Status</h3>
        <ApplicationStatusesInput v-model="conditions.statuses" />
      </b-col>
    </b-form-row>

    <b-form-row>
      <b-col cols="8">
        <h3 class="common__search-title">Date</h3>
        <b-row>
          <b-col>
            <div class="form-group">
              <label class="form-label">From</label>
              <input class="form-control" type="date" v-model="conditions.from">
            </div>
          </b-col>
          <b-col>
            <div class="form-group">
              <label class="form-label">To</label>
              <input class="form-control" type="date" v-model="conditions.to">
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-form-row>

    <b-form-row>
      <b-col cols="8">
        <h3 class="common__search-title">Application Type</h3>
        <ApplicationTypesInput v-model="conditions.types" />
      </b-col>
    </b-form-row>

    <div class="d-flex justify-content-end">
      <b-button
        pill
        variant="secondary"
        @click="reset"
        class="mr-2"
      >
        Reset
      </b-button>
      <b-button
        pill
        variant="primary"
        @click="changeConditions"
      >
        Search
      </b-button>
    </div>
  </b-container>
</template>

<script lang="ts">
import _ from 'lodash'
import moment from 'moment'
import { Component, Vue } from 'vue-property-decorator'
import SearchTutor from '@/components/parts/inputItem/SearchTutor.vue'
import { ApplicationSearchConditions, applicationStatusCode, applicationTypeCode } from '@/store/applications/types'
import ApplicationTypesInput from '@/components/parts/inputItem/ApplicationTypesInput.vue'
import ApplicationStatusesInput from '@/components/parts/inputItem/ApplicationStatusesInput.vue'
import { Tutor } from '@/store/tutors/types'
import { RootState } from '@/store/types'

interface Conditions {
  targetTutor: Tutor|null
  types: applicationTypeCode[]
  statuses: applicationStatusCode[]
  from: Date|null
  to: Date|null
}

const initialConditions: Conditions = {
  targetTutor: null,
  types: [],
  statuses: [],
  from: null,
  to: null,
}

@Component({
  components: {
    SearchTutor,
    ApplicationTypesInput,
    ApplicationStatusesInput,
  },
})
export default class ApplicationSearch extends Vue {
  private conditions: Conditions = _.cloneDeep(initialConditions)

  private get isTutor(): boolean {
    return (this.$store.state as RootState).auth.profile?.authority === 'tutor'
  }

  private changeConditions() {
    const conditions: ApplicationSearchConditions = {
      targetTutor: this.conditions.targetTutor,
      types: this.conditions.types,
      statuses: this.conditions.statuses,
      from: (this.conditions.from && moment(this.conditions.from)) || null,
      to: (this.conditions.to && moment(this.conditions.to)) || null,
    }
    this.$emit('changedConditions', conditions)
  }

  private reset() {
    this.conditions = _.cloneDeep(initialConditions)
    this.changeConditions()
  }
}
</script>

<style scoped>

</style>
